export default "__VITE_ASSET__BzNaqxA2__"